import * as amplitude from "@amplitude/analytics-browser";
import type { EventOptions, AmplitudeReturn } from "@amplitude/analytics-types";
import { AnalyticsEventInput, AnalyticsEventProperties } from "./types";

export type AnalyticsProps = (
  eventInput: AnalyticsEventInput,
  eventProperties?: AnalyticsEventProperties | object,
  eventOptions?: EventOptions
) => AmplitudeReturn<any>;

export const trackAnalytics: AnalyticsProps = (...props) => {
  return amplitude.track(...props);
}
